import historyRouter from 'instantsearch.js/es/lib/routers/history'

/**
 * Sets the URL/search query params mapping.
 *
 * @param {string} indexName The Algolia index name
 *
 * @returns {object} The routing config
 */
export default function searchRouting( indexName ) {
  const router = historyRouter({
    createURL({ qsModule, routeState, location }) {
      const queryParameters = {}

      if ( routeState.s ) {
        queryParameters.s = encodeURIComponent( routeState.s )
      }

      if ( Number( routeState.page ) !== 1 ) {
        queryParameters.page = routeState.page
      }

      const queryString = qsModule.stringify( queryParameters, {
        addQueryPrefix: true,
        arrayFormat: 'repeat',
      })

      const urlParts = location.href.match( /^(.*?)\/\?s=/ )
      const baseUrl = `${ urlParts ? urlParts[ 1 ] : '' }/`

      return `${ baseUrl }${ queryString }`
    },
    parseURL({ qsModule, location }) {
      const { s = '', page } = qsModule.parse(
        location.search.slice( 1 )
      )

      return {
        s: decodeURIComponent( s ),
        page,
      }
    }
  })

  const stateMapping = {
    stateToRoute( uiState ) {
      return {
        s: uiState[ indexName ].query,
        page: uiState[ indexName ].page,
      }
    },
    routeToState( routeState ) {
      return {
        [ indexName ]: {
          query: routeState.s,
          page: routeState.page,
        }
      }
    }
  }

  return {
    router,
    stateMapping,
  }
}
